import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header = ({ title = 'Admin Dashboard' }) => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    setShowDropdown(false);
    await logout();
  };

  const getRoleDisplayName = (role) => {
    switch (role) {
      case 'super_admin': return 'Super Admin';
      case 'admin': return 'Administrator';
      case 'editor': return 'Editor';
      default: return 'User';
    }
  };

  const getUserInitials = (username) => {
    return username ? username.charAt(0).toUpperCase() : 'A';
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1>{title}</h1>
        <p className="header-description">Manage your travel platform</p>
      </div>
      
      <div className="header-right">
        <div className="admin-info">
          <div className="notifications">
            <span className="notification-icon">🔔</span>
          </div>
          
          <div className="admin-profile-container" ref={dropdownRef}>
            <div 
              className={`admin-profile ${showDropdown ? 'active' : ''}`}
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <div className="admin-icon">
                {getUserInitials(user?.username)}
              </div>
              <div className="admin-details">
                <span className="admin-name">{user?.username || 'Admin'}</span>
                <span className="admin-role">{getRoleDisplayName(user?.role)}</span>
              </div>
              <span className={`dropdown-arrow ${showDropdown ? 'open' : ''}`}>
                ▼
              </span>
            </div>

            {showDropdown && (
              <div className="admin-dropdown">
                <div className="dropdown-header">
                  <div className="user-avatar-large">
                    {getUserInitials(user?.username)}
                  </div>
                  <div className="user-info">
                    <div className="user-name">{user?.full_name || user?.username || 'Admin'}</div>
                    <div className="user-email">{user?.email || 'admin@travelfutura.com'}</div>
                    <div className="user-role-badge">
                      {getRoleDisplayName(user?.role)}
                    </div>
                  </div>
                </div>
                
                <div className="dropdown-divider"></div>
                
                <div className="dropdown-menu">
                  <button 
                    className="dropdown-item"
                    onClick={() => {
                      setShowDropdown(false);
                      window.location.href = '/user/profile';
                    }}
                  >
                    <span className="item-icon">👤</span>
                    <span className="item-text">My Profile</span>
                  </button>
                  
                  <button 
                    className="dropdown-item"
                    onClick={() => {
                      setShowDropdown(false);
                      window.location.href = '/user/preferences';
                    }}
                  >
                    <span className="item-icon">⚙️</span>
                    <span className="item-text">Settings</span>
                  </button>
                  
                  {user?.username === 'admin' && (
                    <button 
                      className="dropdown-item admin-item"
                      onClick={() => {
                        setShowDropdown(false);
                        window.location.href = '/admin/users';
                      }}
                    >
                      <span className="item-icon">👥</span>
                      <span className="item-text">User Management</span>
                      <span className="admin-badge">SA</span>
                    </button>
                  )}
                </div>
                
                <div className="dropdown-divider"></div>
                
                <div className="dropdown-footer">
                  <button 
                    className="dropdown-item logout-item"
                    onClick={handleLogout}
                  >
                    <span className="item-icon">🚪</span>
                    <span className="item-text">Sign Out</span>
                    <span className="logout-arrow">→</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 